import { forwardRef } from 'react';
import { useDrag } from '@use-gesture/react';
import V from 'merge-props';
import { clamp01, clamp, mapTo01Linear, mapFrom01Linear } from '@dsp-ts/math';
import { jsx } from 'react/jsx-runtime';
var C = Object.defineProperty;
var m = Object.getOwnPropertySymbols;
var P = Object.prototype.hasOwnProperty,
  H = Object.prototype.propertyIsEnumerable;
var K = (e, o, r) => o in e ? C(e, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[o] = r,
  l = (e, o) => {
    for (var r in o || (o = {})) P.call(o, r) && K(e, r, o[r]);
    if (m) for (var r of m(o)) H.call(o, r) && K(e, r, o[r]);
    return e;
  };
var w = (e, o) => {
  var r = {};
  for (var a in e) P.call(e, a) && o.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && m) for (var a of m(e)) o.indexOf(a) < 0 && H.call(e, a) && (r[a] = e[a]);
  return r;
};
var v = "vertical",
  L = !1,
  T = mapTo01Linear,
  D = mapFrom01Linear,
  c = forwardRef((_, R) => {
    var f = _,
      {
        valueRaw: e,
        valueMin: o,
        valueMax: r,
        dragSensitivity: a,
        valueRawRoundFn: p,
        valueRawDisplayFn: t,
        onValueRawChange: s,
        orientation: u = v,
        includeIntoTabOrder: n = L,
        mapTo01: y = T,
        mapFrom01: O = D
      } = f,
      N = w(f, ["valueRaw", "valueMin", "valueMax", "dragSensitivity", "valueRawRoundFn", "valueRawDisplayFn", "onValueRawChange", "orientation", "includeIntoTabOrder", "mapTo01", "mapFrom01"]);
    let g = p(e),
      k = useDrag(_ref => {
        let {
          delta: d
        } = _ref;
        let F = u === "horizontal" ? d[0] * a : d[1] * -a,
          A = y(e, o, r),
          I = clamp01(A + F),
          h = clamp(O(I, o, r), o, r);
        s(h);
      }, {
        pointer: {
          keys: !1
        }
      });
    return jsx("div", l({
      ref: R,
      role: "slider",
      "aria-valuenow": g,
      "aria-valuemin": o,
      "aria-valuemax": r,
      "aria-orientation": u,
      "aria-valuetext": t(e),
      tabIndex: n ? 0 : -1
    }, V(k(), {
      style: {
        touchAction: "none"
      },
      onPointerDown(d) {
        d.currentTarget.focus();
      }
    }, N)));
  });
c.displayName = "KnobHeadless";
c.defaultProps = {
  orientation: v,
  includeIntoTabOrder: L,
  mapTo01: T,
  mapFrom01: D
};
var x = forwardRef((e, o) => jsx("label", l({
  ref: o
}, e)));
x.displayName = "KnobHeadlessLabel";
var E = forwardRef((e, o) => jsx("output", l({
  ref: o
}, e)));
E.displayName = "KnobHeadlessOutput";
var Z = _ref2 => {
    let {
      valueRaw: e,
      valueMin: o,
      valueMax: r,
      step: a,
      stepLarger: p,
      onValueRawChange: t,
      noDefaultPrevention: s = !1
    } = _ref2;
    return {
      onKeyDown: n => {
        let {
          code: y
        } = n;
        switch (y) {
          case "ArrowUp":
          case "ArrowRight":
            t(clamp(e + a, o, r), n), b({
              event: n,
              noDefaultPrevention: s
            });
            break;
          case "ArrowDown":
          case "ArrowLeft":
            t(clamp(e - a, o, r), n), b({
              event: n,
              noDefaultPrevention: s
            });
            break;
          case "PageUp":
            t(clamp(e + p, o, r), n), b({
              event: n,
              noDefaultPrevention: s
            });
            break;
          case "PageDown":
            t(clamp(e - p, o, r), n), b({
              event: n,
              noDefaultPrevention: s
            });
            break;
          case "Home":
            t(o, n), b({
              event: n,
              noDefaultPrevention: s
            });
            break;
          case "End":
            t(r, n), b({
              event: n,
              noDefaultPrevention: s
            });
            break;
        }
      }
    };
  },
  b = _ref3 => {
    let {
      event: e,
      noDefaultPrevention: o
    } = _ref3;
    o || e.preventDefault();
  };
export { c as KnobHeadless, x as KnobHeadlessLabel, E as KnobHeadlessOutput, Z as useKnobKeyboardControls };
//# sourceMappingURL=out.js.map